module.exports = __webpack_public_path__ + "static/media/consumerlaw.a0e42411.svg";